import React, { useEffect, useState } from "react";
import StyledPeoplePage from "./style.js";
import { Tabs, Input, Button, Table, Modal, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ReactComponent as Edit1 } from "../../../../assets/Icons/edit1.svg";
import { ReactComponent as Delete1 } from "../../../../assets/Icons/delete1.svg";
import EditCustomField from "./EditCustom.js";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import { ReactComponent as Deleted } from "../../../../assets/Icons/deleted.svg";
import { ReactComponent as Hamburger } from "../../../../assets/Icons/hamburger.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useDispatch, useSelector } from "react-redux";
import FetchData from "../../../../hooks/FetchData.js";
import {
  setGetCreateAllCustomPeople,
  setGetCreateAllPeopleType,
} from "../../../../Redux/systemSlice.js";
import PostUpdateData from "../../../../hooks/postUpdate.js";
import DeleteModal from "./DeleteModal.js";

const SortableItem = ({ id, label }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: "grab",
    margin: "8px 0",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "5px",
    boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    columnGap: "8px",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <span style={{ cursor: "grab" }}>
        <Hamburger />
      </span>
      <span>{label}</span>
    </div>
  );
};

const Peoples = () => {
  const location = useLocation();
  // Coming back from Creating/Editing People Type should land on the
  // People Type tab, not silently reset to Custom Field - the tab is
  // passed via navigate("/settings-people", { state: { activeKey } }).
  const [activeKey, setActiveKey] = useState(location.state?.activeKey || "1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletedModalVisible, setDeletedModalVisible] = useState(false);
  const [reorderModalVisible, setReorderModalVisible] = useState(false);
  const [customView, setCustomView] = useState("people");
  const [selectedData, setSelectedData] = useState();
  const [selectedId, setSelectedId] = useState("");
  const [savedModalVisible, setSavedModalVisible] = useState(false);
  const [selectDeleteData, setSelectDeleteData] = useState();
  const [isEditMode, setIsEditMode] = useState("");
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [peopleTypeSearchTerm, setPeopleTypeSearchTerm] = useState("");
  const [customData, setCustomData] = useState([]);
  const [peopleType, setPeopleType] = useState([]);
  const [items1, setItems1] = useState([]);
  const [reorderSaving, setReorderSaving] = useState(false);
  const [reorderTypeModalVisible, setReorderTypeModalVisible] = useState(false);
  const [itemsType, setItemsType] = useState([]);
  const [reorderTypeSaving, setReorderTypeSaving] = useState(false);

  const getCreateAllCustomPeople = useSelector(
    (state) => state.systemTracking.getCreateAllCustomPeople
  );
  const getCreateAllPeopleType = useSelector(
    (state) => state.systemTracking.getCreateAllPeopleType
  );
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const dispatch = useDispatch();

  const handleGetPeopleData = async () => {
    if (!userInfo.clientId) return;
    const endpoint = `/settings/getuserType/${userInfo.clientId}`;
    try {
      const response = await FetchData({ endPoint: endpoint });
      if (response?.statusCode === 200 || response?.statusCode === 201) {
        const formattedData = response.menulist.map((item2) => {
          // return { ...unused mapping preserved from original... };
        });
        dispatch(setGetCreateAllPeopleType(response?.menulist));
        setPeopleType(formattedData);
      } else {
        setPeopleType([]);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  useEffect(() => {
    // See Settings > Account's index.js for why this depends on clientId
    // instead of running once on mount - same hard-refresh race.
    handleGetPeopleData();
  }, [userInfo.clientId]);

  const handleGetCustomData = async () => {
    if (!userInfo.clientId) return;
    const endpoint = `/settings/getuserfield/${userInfo.clientId}`;
    try {
      const response = await FetchData({ endPoint: endpoint });

      if (response?.statusCode === 200 && response?.response?.length > 0) {
        // The backend already returns these ordered by display_order ASC
        // (NULLS LAST) - reversing here inverted every reorder save, so
        // dragging a field to the top made it show up at the bottom.
        const formattedData = response.response.map((item) => ({
          key: item.field_id,
          field_name: item.field_name,
          type: item.field_type,
          mandatory: item.mandatory === true ? "Yes" : "No",
          visible: item.visible_on_report === true ? "Yes" : "No",
          field_id: item?.field_id,
          field_options: item?.field_options,
        }));
        dispatch(setGetCreateAllCustomPeople(formattedData));
        setCustomData(formattedData);
      } else {
        setCustomData([]);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  useEffect(() => {
    // See Settings > Account's index.js for why this depends on clientId
    // instead of running once on mount - same hard-refresh race.
    handleGetCustomData();
  }, [userInfo.clientId]);

  const handleDeleteCustomData = async () => {
    const endpoint = `/settings/deleteuserfield/${userInfo.clientId}/${selectedId}`;
    try {
      const response = await PostUpdateData({
        endPoint: endpoint,
        method: "DELETE",
      });
      if (response?.status === 200) {
        handleGetCustomData();
        handleCancel();
        setDeletedModalVisible(true);
        setTimeout(() => {
          setDeletedModalVisible(false);
        }, 2000);
      } else {
        message.error("Error");
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const filteredData = customData.filter((item) =>
    item.field_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPeopleType = (getCreateAllPeopleType || []).filter((item) =>
    (item.name || "").toLowerCase().includes(peopleTypeSearchTerm.toLowerCase())
  );

  const onChange = (key) => {
    setActiveKey(key);
  };

  // Seed the reorder list from live customData every time the modal opens,
  // so it reflects real field_ids instead of stale/dummy data.
  const showReorderModal = () => {
    const mapped = customData.map((item) => ({
      id: String(item.field_id),
      label: item.field_name,
      field_id: item.field_id,
    }));
    setItems1(mapped);
    setReorderModalVisible(true);
  };

  const handleReorderOk = async () => {
    if (!items1.length) {
      message.error("Nothing to reorder");
      return;
    }

    const payload = items1.map((item, index) => ({
      field_id: item.field_id,
      display_order: index + 1,
    }));

    const endpoint = `/settings/reorderuserfield/${userInfo.clientId}`;

    setReorderSaving(true);
    try {
      const response = await PostUpdateData({
        endPoint: endpoint,
        // The backend route is PUT-only (event.httpMethod === "PUT" in
        // tymeplushrlmssettings/app.mjs) - this sent POST, which the
        // backend rejects with 400 "No Route Found" on every attempt.
        // Confirmed live: POST -> 400, PUT -> 200.
        method: "put",
        // postUpdate.js's PostUpdateData reads `obj`, not `data` - that's
        // useApi's request()'s parameter name, a different hook. Passing
        // `data:` here silently dropped the whole payload.
        obj: payload,
      });

      if (response?.status === 200 || response?.statusCode === 200) {
        setReorderModalVisible(false);
        handleGetCustomData();
        setSavedModalVisible(true);
        setTimeout(() => setSavedModalVisible(false), 2000);
      } else {
        message.error("Error saving order");
      }
    } catch (error) {
      console.error("error", error);
      message.error("Error saving order");
    } finally {
      setReorderSaving(false);
    }
  };

  const handleReorderCancel = () => {
    setReorderModalVisible(false);
  };

  // Same pattern as Custom Field's reorder above, for People Type.
  const showReorderTypeModal = () => {
    const mapped = getCreateAllPeopleType.map((item) => ({
      id: String(item.usertype_id),
      label: item.name,
      usertype_id: item.usertype_id,
    }));
    setItemsType(mapped);
    setReorderTypeModalVisible(true);
  };

  const handleReorderTypeOk = async () => {
    if (!itemsType.length) {
      message.error("Nothing to reorder");
      return;
    }

    const payload = itemsType.map((item, index) => ({
      usertype_id: item.usertype_id,
      display_order: index + 1,
    }));

    const endpoint = `/settings/reorderusertype/${userInfo.clientId}`;

    setReorderTypeSaving(true);
    try {
      const response = await PostUpdateData({
        endPoint: endpoint,
        method: "put",
        obj: payload,
      });

      if (response?.status === 200 || response?.statusCode === 200) {
        setReorderTypeModalVisible(false);
        handleGetPeopleData();
        setSavedModalVisible(true);
        setTimeout(() => setSavedModalVisible(false), 2000);
      } else {
        message.error("Error saving order");
      }
    } catch (error) {
      console.error("error", error);
      message.error("Error saving order");
    } finally {
      setReorderTypeSaving(false);
    }
  };

  const handleReorderTypeCancel = () => {
    setReorderTypeModalVisible(false);
  };

  const onDragEndType = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItemsType((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModal = (record) => {
    setIsModalOpen(true);
    setSelectedId(record.field_id);
  };

  const handleDelete = (record) => {
    setIsModalOpen(true);
    setSelectDeleteData(record);
  };

  const handleConfirmDelete = async () => {
    const endpoint = `/settings/deleteusertype/${userInfo.clientId}/${selectDeleteData?.usertype_id}`;
    try {
      const response = await PostUpdateData({
        endPoint: endpoint,
        method: "DELETE",
      });
      if (response?.status === 200) {
        handleGetPeopleData();
        handleCancel();
        setDeletedModalVisible(true);
        setTimeout(() => {
          setDeletedModalVisible(false);
        }, 2000);
      } else {
        message.error("Error");
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: activeKey === "1" ? "#1F243B" : "#636980",
          }}
        >
          Custom Field
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: activeKey === "2" ? "#1F243B" : "#636980",
          }}
        >
          People Type
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "field_name",
      key: "field_name",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // Stored/sent as the Select option's lowercase value ("text",
      // "dropdown", ...) - capitalize only for display here.
      render: (text) =>
        text ? text.charAt(0).toUpperCase() + text.slice(1) : text,
    },
    {
      title: "Mandatory",
      dataIndex: "mandatory",
      key: "mandatory",
    },
    {
      title: "Visible on Reports",
      dataIndex: "visible",
      key: "visible",
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => (
        <div className="action-icons">
          <Edit1
            className="edit-icon"
            onClick={() => {
              handleRowClick(record);
              setCustomView("custom-edit");
            }}
          />
          <Delete1 className="delete-icon" onClick={() => showModal(record)} />
        </div>
      ),
    },
  ];
  const columns1 = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => {
        return <div style={{ textAlign: "left" }}>{text}</div>;
      },
    },
    {
      title: "Administrator",
      dataIndex: "administrator",
      key: "administrator",
      align: "center",
      render: (_, record) => {
        const hasAccess = record?.administrator?.status === true;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {hasAccess ? <Tick /> : "-"}
          </div>
        );
      },
    },
    {
      title: "Tutor",
      dataIndex: "tutor",
      key: "tutor",
      align: "center",
      render: (_, record) => {
        const hasAccess = record?.tutor?.status === true;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {hasAccess ? <Tick /> : "-"}
          </div>
        );
      },
    },
    {
      title: "Learner",
      dataIndex: "learner",
      key: "learner",
      align: "center",
      render: (_, record) => {
        const hasAccess = record?.learner?.status === true;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {hasAccess ? <Tick /> : "-"}
          </div>
        );
      },
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => {
        if (record.name === "Super Admin") {
          return null;
        }
        return (
          <div className="action-icons">
            <Edit1
              className="edit-icon"
              onClick={() => {
                // Navigate to CreatingPeopleType in edit mode, passing the
                // full record (needed for usertype_id + existing permissions).
                navigate("/settings-peopletype?mode=edit", {
                  state: { record },
                });
              }}
            />
            <Delete1
              className="delete-icon"
              onClick={() => handleDelete(record)}
            />
          </div>
        );
      },
    },
  ];

  const handleRowClick = (record) => {
    setSelectedData(record);
    setCustomView("people");
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 1 },
    })
  );

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItems1((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
    }
  };

  return (
    <>
      <StyledPeoplePage>
        {customView === "people" &&
          (activeKey === "1" || activeKey === "2") && (
            <div className="first-people">People</div>
          )}
        {activeKey === "1" && (
          <>
            {customView === "people" ? (
              <>
                <Tabs
                  activeKey={activeKey}
                  items={items}
                  onChange={onChange}
                  tabBarStyle={{ width: "215px" }}
                />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <Input
                      placeholder="Search name"
                      prefix={<SearchOutlined style={{ color: "#636980" }} />}
                      className="searchbar-style"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button
                      className="reorder-button"
                      onClick={showReorderModal}
                    >
                      Reorder
                    </Button>
                    <Button
                      className="create-field-button"
                      onClick={() => {
                        setSelectedData("");
                        setCustomView("custom-table");
                      }}
                    >
                      + Create Field
                    </Button>
                  </div>
                </div>
                <br />
                <div>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "table-row-white" : "table-row-gray"
                    }
                    className="custom-table"
                  />
                </div>
              </>
            ) : (
              <>
                <EditCustomField
                  setCustomView={setCustomView}
                  selectedData={selectedData}
                  customView={customView}
                  handleGetCustomData={handleGetCustomData}
                />
              </>
            )}
          </>
        )}
        <Modal
          width={631}
          height={481}
          title="Reordering"
          open={reorderModalVisible}
          onOk={handleReorderOk}
          onCancel={handleReorderCancel}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px",
              }}
            >
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  color: "#1F243B",
                  border: "1px solid #1F243B",
                  borderRadius: "8px",
                }}
                onClick={handleReorderCancel}
              >
                Cancel
              </button>
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  backgroundColor: "#C2FAE5",
                  color: "#1F243B",
                  borderRadius: "8px",
                  opacity: reorderSaving ? 0.6 : 1,
                }}
                onClick={handleReorderOk}
                disabled={reorderSaving}
              >
                {reorderSaving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          }
        >
          <DndContext
            sensors={sensors}
            modifiers={[restrictToVerticalAxis]}
            onDragEnd={onDragEnd}
          >
            <SortableContext
              items={items1.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {items1.map((item) => (
                <SortableItem key={item.id} id={item.id} label={item.label} />
              ))}
            </SortableContext>
          </DndContext>
          <br />
          <br />
        </Modal>

        <Modal
          width={631}
          height={481}
          title="Reordering"
          open={reorderTypeModalVisible}
          onOk={handleReorderTypeOk}
          onCancel={handleReorderTypeCancel}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px",
              }}
            >
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  color: "#1F243B",
                  border: "1px solid #1F243B",
                  borderRadius: "8px",
                }}
                onClick={handleReorderTypeCancel}
              >
                Cancel
              </button>
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  backgroundColor: "#C2FAE5",
                  color: "#1F243B",
                  borderRadius: "8px",
                  opacity: reorderTypeSaving ? 0.6 : 1,
                }}
                onClick={handleReorderTypeOk}
                disabled={reorderTypeSaving}
              >
                {reorderTypeSaving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          }
        >
          <DndContext
            sensors={sensors}
            modifiers={[restrictToVerticalAxis]}
            onDragEnd={onDragEndType}
          >
            <SortableContext
              items={itemsType.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {itemsType.map((item) => (
                <SortableItem key={item.id} id={item.id} label={item.label} />
              ))}
            </SortableContext>
          </DndContext>
          <br />
          <br />
        </Modal>

        <Modal
          open={savedModalVisible}
          footer={null}
          centered
          closable={false}
          width={180}
          height={100}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            <Tick style={{ width: "34px", height: "34px" }} />
            <p
              style={{
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              Saved
            </p>
          </div>
        </Modal>

        <DeleteModal
          isModalOpen={isModalOpen}
          handleDelete={
            activeKey === "1" ? handleDeleteCustomData : handleConfirmDelete
          }
          handleCancel={handleCancel}
        />
        <Modal
          open={deletedModalVisible}
          footer={null}
          centered
          closable={false}
          width={198}
          height={100}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            <Deleted />
            <p
              style={{
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              Deleted
            </p>
          </div>
        </Modal>
        {activeKey === "2" && (
          <>
            <Tabs
              activeKey={activeKey}
              items={items}
              onChange={onChange}
              tabBarStyle={{ width: "215px" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Input
                  placeholder="Search"
                  prefix={<SearchOutlined style={{ color: "#636980" }} />}
                  className="searchbar-style"
                  value={peopleTypeSearchTerm}
                  onChange={(e) => setPeopleTypeSearchTerm(e.target.value)}
                />
              </div>
              <div>
                <Button
                  className="reorder-button"
                  onClick={showReorderTypeModal}
                >
                  Reorder
                </Button>
                <Button
                  className="create-field-button"
                  onClick={() => navigate("/settings-peopletype?mode=create")}
                >
                  + Create People Type
                </Button>
              </div>
            </div>
            <br />
            <div>
              <Table
                columns={columns1}
                dataSource={filteredPeopleType}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-white" : "table-row-gray"
                }
                className="custom-table"
              />
            </div>
          </>
        )}
      </StyledPeoplePage>
    </>
  );
};

export default Peoples;